"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("./SvgIcon"));
const External = (_a) => {
    var rest = __rest(_a, []);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ "data-icon": "external", viewBox: "0 0 13 12", fill: "none" }, rest),
        react_1.default.createElement("g", { clipPath: "url(#clip0)" },
            react_1.default.createElement("path", { d: "M11.3991 0.943893L5.2627 7.08026", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            react_1.default.createElement("path", { d: "M1.44038 0.943851L1.44037 11.2894", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            react_1.default.createElement("path", { d: "M11.3984 11.2894H1.43951", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            react_1.default.createElement("path", { d: "M11.3985 5.0348V0.943893H7.30762", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0" },
                react_1.default.createElement("rect", { width: "12", height: "12", fill: "white", transform: "translate(0.416016)" })))));
};
exports.default = External;
//# sourceMappingURL=External.js.map